import './style.css';

import { Modal } from 'rsuite';

import { useTranslation, Trans } from "react-i18next";

const ForgotPasswordModal = ({show, setShow}) => {

    const { t, i18n } = useTranslation();
    return (
        <Modal className="forgot-password-modal" open={show} onClose={() => setShow(false)}>
            {t('reset-password-modal')}
        </Modal>
    )
}

export default ForgotPasswordModal;